import type { RoadmapItem } from "../types/roadmap";

/**
 * Roadmap público para visitantes e doadores.
 * Títulos/descrições: i18n `roadmap.items.{id}.title|description`.
 * Milestones (sub-marcos): i18n `roadmap.items.{id}.milestones.{milestoneId}`.
 * `milestones` traduz o trabalho real para linguagem de doador: para as frentes em
 * progresso, vem das specs em `specs/NNN-*`; para as frentes planejadas, vem da visão
 * de design em `docs/LivinPixel_GameBible.html` (todas com status "upcoming" até a
 * frente entrar em progresso — atualize os status junto quando isso acontecer).
 * Custos = metas de arrecadação por frente (total R$ 300.000).
 */
export const roadmapItems: RoadmapItem[] = [
  {
    id: "world-base",
    status: "in-progress",
    progress: 60,
    cost: 30000,
    funded: 0,
    milestones: [
      { id: "infra-servidor", status: "done" },
      { id: "pipeline-arte", status: "done" },
      { id: "vitrine-praca-ao-vivo", status: "done" },
      { id: "observabilidade", status: "done" },
      { id: "hardening-continuo", status: "current" },
    ],
  },
  {
    id: "engine-avatar",
    status: "in-progress",
    progress: 75,
    cost: 35000,
    funded: 0,
    milestones: [
      { id: "mundo-salas-camera", status: "done" },
      { id: "movimento-teclado", status: "done" },
      { id: "minimapa-hud", status: "done" },
      { id: "continente", status: "done" },
      { id: "editor-terreno", status: "done" },
      { id: "verticalidade-andares", status: "done" },
      { id: "painel-obra", status: "done" },
      { id: "escala-cidade", status: "current" },
    ],
  },
  {
    id: "production",
    status: "in-progress",
    progress: 10,
    cost: 30000,
    funded: 0,
    milestones: [
      { id: "primeira-ferramenta", status: "done" },
      { id: "coleta-recursos", status: "current" },
      { id: "transporte-logistica", status: "upcoming" },
      { id: "refino-receitas", status: "upcoming" },
      { id: "comercializacao-loja", status: "upcoming" },
      { id: "cadeia-exemplo-pao", status: "upcoming" },
    ],
  },
  {
    id: "commerce",
    status: "in-progress",
    progress: 10,
    cost: 30000,
    funded: 0,
    milestones: [
      { id: "inventario-estoque", status: "current" },
      { id: "lifecoins-circulacao", status: "upcoming" },
      { id: "veiculos-logistica", status: "upcoming" },
      { id: "montar-estabelecimento", status: "upcoming" },
      { id: "qualidade-mercado", status: "upcoming" },
    ],
  },
  {
    id: "living-city",
    status: "in-progress",
    progress: 10,
    cost: 35000,
    funded: 0,
    milestones: [
      { id: "polos-territorio", status: "current" },
      { id: "npcs-consumo-producao", status: "upcoming" },
      { id: "fronteira-aberta", status: "upcoming" },
      { id: "guildas-corporacoes", status: "upcoming" },
      { id: "marcos-legado", status: "upcoming" },
    ],
  },
  {
    id: "survival-hub",
    status: "in-progress",
    progress: 60,
    cost: 30000,
    funded: 0,
    milestones: [
      { id: "amigos-chat", status: "done" },
      { id: "voz-proximidade", status: "done" },
      { id: "compartilhamento-tela", status: "done" },
      { id: "gestos-sociais", status: "done" },
      { id: "dj-sala", status: "done" },
      { id: "hub-celular", status: "current" },
      { id: "necessidades-continuas", status: "upcoming" },
      { id: "conforto-desempenho", status: "upcoming" },
      { id: "rotina-idle-cuidados", status: "upcoming" },
    ],
  },
  {
    id: "skills-lots",
    status: "planned",
    progress: 0,
    cost: 35000,
    funded: 0,
    milestones: [
      { id: "familias-skills", status: "upcoming" },
      { id: "livros-especializacao", status: "upcoming" },
      { id: "sistema-imobiliario", status: "upcoming" },
      { id: "contratos-emprego", status: "upcoming" },
      { id: "perfil-curriculo", status: "upcoming" },
    ],
  },
  {
    id: "polish",
    status: "in-progress",
    progress: 25,
    cost: 30000,
    funded: 0,
    milestones: [
      { id: "traducao-pt-en", status: "done" },
      { id: "acessibilidade-teclado", status: "current" },
      { id: "contraste-reduced-motion", status: "current" },
      { id: "performance-mobile", status: "current" },
      { id: "trilha-efeitos", status: "upcoming" },
    ],
  },
  {
    id: "open-beta",
    status: "in-progress",
    progress: 25,
    cost: 45000,
    funded: 0,
    milestones: [
      { id: "instalavel-windows", status: "done" },
      { id: "home-direta-seo", status: "done" },
      { id: "convites-beta", status: "current" },
      { id: "onboarding-novato", status: "upcoming" },
      { id: "canais-feedback", status: "upcoming" },
      { id: "testes-comunidade", status: "upcoming" },
      { id: "estabilidade-carga", status: "upcoming" },
      { id: "lancamento-aberto", status: "upcoming" },
    ],
  },
];
